import {
    SELECT_MEDIA,               DESELECT_MEDIA,
    SELECT_ALL_MEDIA,           DESELECT_ALL_MEDIA,
    REQUEST_DELETE_MEDIA,       RECIEVE_DELETE_MEDIA,
    REQUEST_MEDIA_REPROCESSING, RECIEVE_MEDIA_REPROCESSING,
    REQUEST_UPDATE_MEDIA,       RECIEVE_UPDATE_MEDIA, 
} from '../constants/actionTypes';

export const mediaItem = (state, action) => {
    switch(action.type){
        case SELECT_ALL_MEDIA:
        case SELECT_MEDIA:
            return {
                ...state,
                selected: true
            };

        case DESELECT_ALL_MEDIA:
        case DESELECT_MEDIA:
            return {
                ...state,
                selected: false
            };
        
        case REQUEST_DELETE_MEDIA:
            return {
                ...state,
                deleting: true
            };

        case RECIEVE_DELETE_MEDIA:
            return {
                ...state,
                deleting: false
            };
        
        case REQUEST_MEDIA_REPROCESSING:
            return {
                ...state,
                reprocessing: true
            };

        case RECIEVE_MEDIA_REPROCESSING:
            return {
                ...state,
                reprocessing: false
            };

        case REQUEST_UPDATE_MEDIA:
            return {
                ...state,
                updating: true
            };

        case RECIEVE_UPDATE_MEDIA:
            return {
                ...state,
                updating: false
            };

        default:
            return state;
    }    
};



// WEBPACK FOOTER //
// ./src/reducers/mediaItem.js